import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Formik, Form, Field, FieldArray, FastField } from "formik";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import StripeWrapper from "./CheckoutForm";
import { useSelector } from "react-redux";
import stripeimg from "../../assets/Stripe.png"
import paymentimg from "../../assets/payment.png"


const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  button: {
    margin: theme.spacing(3),
    fontFamily: "Calibri",
    fontWeight: "bold",
    color: "White",
    fontSize: "15px",
    width: "100%",
    marginLeft: "auto",
  },
}));

function OrderSummary() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const SubscriptionDetail = useSelector(
    (state) => state.company.subscriptionDetail
  );
  const CompanyDetail = useSelector((state) => state.company.companyDetail);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const initialValues = {
    id: CompanyDetail?.issue_name,
    Owner: CompanyDetail?.description,
    package: CompanyDetail?.suggested_status,
    number_of_users: CompanyDetail?.report_status,
    price_per_month: CompanyDetail?.start_date,
    subscription_renewal_period: CompanyDetail?.type,
    schedule: CompanyDetail?.schedule,
    item: CompanyDetail?.item
  };
  
  const onSubmit = (values, onSubmitProps) => {
    console.log("Value", values)
    
  };
  return (
    <>
      <div className="container w-4/5 mx-auto px-4 ">
        <div className="bg-white shadow-xl text-gray-200 rounded-lg">
          
          <div className="flex flex-col justify-items-center ml-8 p-8">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={onSubmit}
          //   validationSchema={validationSchema}
          //   validateOnMount
        >
          <Form>
           
            <div className="grid space-y-8">
             
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Company Name</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Description</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                             Address </label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Country</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              
              <div className="w-full flex flex-wrap">
              <Field name="item " >
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap w-1/2">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              City</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5  px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5  px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                      
                    </>
                  );
                }}
              </Field>
              <Field name="item  ">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap w-1/2">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                             Postal Code </label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5  px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5  px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                      
                    </>
                  );
                }}
              </Field>
              </div>
              <Field name="id">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Selected Plan</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Users</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Balanace VAT</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Current Price</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
              <Field name="item">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                       <div className="mt-4 flex flex-wrap">
                        <label className="my-4 w-1/6 text-black font-Montserrat font-medium flex flex-wrap">
                              Payment Interval</label>
                        
                        <input
                          // onChange={handleChange}
                          // value={User}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-2 rounded-lg relative block w-4/5 ml-4 px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder=""
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </div>
                    </>
                  );
                }}
              </Field>
            </div>
           

          </Form>
        </Formik>
      </div>
        </div>
      </div>
      <div className="container w-3/4 mx-auto px-4 ">
      <div className="flex mx-auto flex-wrap items-center place-content-center my-8">
<img  src={paymentimg} alt="stripe"></img>
        </div>
        <button
          type="button"
          onClick={handleClickOpen}
          className="mt-3 font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
        >
          Continue to Card Details
        </button>
        <div className="flex mx-auto flex-wrap items-center place-content-center mt-8">
Continue payment with <img width="70" height="40" src={stripeimg} alt="stripe"></img>
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Checkout</DialogTitle>
        <DialogContent>
          <StripeWrapper setOpen={setOpen} />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default OrderSummary;
